/** Obyektdan kalitlar bo'yicha birinchi mavjud qiymatni qaytaradi. */
export const firstDefined = (obj, keys) => {
    if (!obj) return undefined;
    for (const k of keys) {
        if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
    }
    return undefined;
};

/** Katalog massivini Ant Select options ga aylantiradi (himoyalangan). */
export const toOptions = (arr, codeKeys, nameKeys) =>
    (Array.isArray(arr) ? arr : [])
        .map((it) => {
            const code = firstDefined(it, codeKeys);
            const name = firstDefined(it, nameKeys);
            if (code === undefined) return null;
            return { value: code, label: name !== undefined ? `${name} (${code})` : String(code) };
        })
        .filter(Boolean);

/** Pul formati. */
export const money = (v) => Number(v || 0).toLocaleString("ru-RU").replace(/,/g, " ");

/** Status kodiga qarab rang. */
export const statusColor = (code) => {
    const c = Number(code);
    if ([100, 1].includes(c)) return "blue";       // yangi
    if ([200, 2, 300].includes(c)) return "orange"; // jarayonda
    if ([400, 4, 500].includes(c)) return "green";  // yetkazildi
    if ([900, 9, -1].includes(c)) return "red";     // bekor
    return "default";
};
